/* Change this modal to browser all company from ERP system because its have to use bot dconnect and 2sonline */
import { useRedux } from "hooks";
import React, { useCallback, useEffect, useState } from "react";
import {
  Form,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Input,
  Spinner,
} from "reactstrap";
import { createSelector } from "reselect";
import Loader from "./Loader";
import { generateGroupInviteCodeAsync, getGroupInviteCodeAsync } from "../api/chats";
import { findDConnectCusForMatch, findErpSupForMatch } from "../redux/profile2/p2_reducer";
import { addUserToGroup, getChatUserDetails2s } from "../redux/actions";
import { setCustomerId, updateUnreadCount } from "../redux/chats/slice";
import { Exception } from "sass";
import { Utils } from "helpers/utils";
import FormInput from "./FormInput";
import UserAvatar from "./UserAvatar";
import { debounce } from "lodash";
import TxtAtoFindUser from "./TxtAtoFindUser";
import { APIClient } from "api/apiCore";
import LoadingIconWithText from "./LoadingIconWithText";
import TextBox from "./TextBox";
import { UserTypes } from "api";



interface SearchCustomerModalV2Props {
  isOpen: boolean;
  onClose: () => void;
  groupId: number;
  groupType: UserTypes;
  groupName: any;
}

const SearchCustomerModalV2 = ({
  isOpen,
  onClose,
  groupId,
  groupName,
  groupType,
}: SearchCustomerModalV2Props) => {
  // console.log('SearchCustomerModalV2 Parm:', { isOpen, onClose, groupId, groupName, groupType });
  const { dispatch, useAppSelector } = useRedux();
  const storeData = createSelector(
    (state) => state.Profile2,
    (state) => ({
      // groupInviteCode: state.groupInviteCode,
      // groupInviteOn: state.groupInviteOn,
      profile2: state,
      findDConnectCust: state.findDConnectCust,
      findDConnectCustOn: state.findDConnectCustOn,
      findErpSup: state.findErpSup,
      findErpSupOn: state.findErpSupOn
    })
  );
  const { /*groupInviteCode, groupInviteOn,*/ profile2, findDConnectCust, findDConnectCustOn, findErpSup, findErpSupOn } = useAppSelector(storeData);
  // console.log('profile2:', profile2);
  const [isGenCode, setIsGenCode] = useState<boolean>(false);
  const [errMessage, _a1] = useState<string>("");
  const [errClass, _a2] = useState<string>("danger");
  const [groupInviteCode, setGroupInviteCode] = useState('');
  const [groupInfo, setGroupInfo] = useState<any>(null);
  const [toggleLoadGroupInfo, setToggleLoadGroupInfo] = useState<boolean>(false);
  // console.log('profile2:', profile2);
  const capPartner = groupType == UserTypes.Group ? "ลูกค้า" : groupType == UserTypes.GroupSupplier ? "Supplier" : "N/A";

  useEffect(() => {
    // console.log('profile2-2:', profile2);
    const api = new APIClient()
    const fetch = async () => {
      await api.fnPostForm("/load-group-chat-with-dconnect-company", { groupChatId: groupId })
        .then(response => {
          // console.log('load-group-chat-with-dconnect-company:', response);
          setGroupInfo(response)
        })
        .catch(err => console.error(err));
    }
    fetch();
    // console.log('groupId:', groupId);
  }, [groupId, toggleLoadGroupInfo, groupName]);


  const onModalClose = () => {
    onClose();
  }

  const [lastFilter, setLastFilter] = useState("");
  const [filterCustomerCode, setFilterCustomerCode] = useState("");
  const [filterCustomerName, setFilterCustomerName] = useState("");

  const onAddMember = async (userId: number) => {
    dispatch(addUserToGroup(groupId, userId, true));
  }

  const onClickUnMatch = async (groupId: any, chatRoomName: any, dConnectCompany: any) => {

    Utils.SweetConfirm(`ยกเลิกจับคู่ <b>${capPartner}</b> <br/><u class="text-red">` + dConnectCompany + '</u></br>กับห้องแชท</br><u class="text-red">' + chatRoomName + '</u></br>ใช่หรือไม่')
      .then((result) => {
        if (result.isConfirmed) {
          const api = new APIClient()
          api.fnPostForm("/apply-customerid-to-groupchat", {
            groupChatId: groupInfo?.groupId, companyId: -1
          })
            .then(response => {
              // alert('จับคู่สำเร็จ');
              dispatch(getChatUserDetails2s(groupInfo?.groupId, false, true, false));
              setToggleLoadGroupInfo((prev) => !prev);
              dispatch(findDConnectCusForMatch(filterCustomerCode, filterCustomerName));
              dispatch(setCustomerId({ userOrGroupId: groupInfo?.groupId, companyId: undefined }));
              onModalClose();
            })
            .catch(err => {
              alert('มีข้อผิดพลาด');
              console.error(err)
            });
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  const onClickMatch = async (companyId: any, companyName: any, appName: any) => {
    const appNameShow = appName ? ('&nbsp;(' + appName + ')') : '';
    Utils.SweetConfirm(`จับคู่ <b>${capPartner}</b>  <br/><u class="text-red">` + companyName + appNameShow + '</u></br>กับห้องแชท</br><u class="text-red">' + groupInfo?.groupName + '</u></br>ใช่หรือไม่')
      .then((result) => {
        if (result.isConfirmed) {
          const api = new APIClient()
          api.fnPostForm("/apply-customerid-to-groupchat", {
            groupChatId: groupInfo?.groupId, companyId: companyId
          })
            .then(response => {
              // alert('จับคู่สำเร็จ');
              dispatch(getChatUserDetails2s(groupInfo?.groupId, false, true, false));
              setToggleLoadGroupInfo((prev) => !prev);
              dispatch(findDConnectCusForMatch(filterCustomerCode, filterCustomerName)); // refresh list
              dispatch(setCustomerId({ userOrGroupId: groupInfo?.groupId, companyId: companyId }));
              onModalClose();
              // console.log(response);
              // setGroupInfo(response)
            })
            .catch(err => {
              alert('มีข้อผิดพลาด');
              console.error(err)
            });
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }

  const onSearchClick = () => {
    try {
      if (groupType == UserTypes.Group) {
        dispatch(findDConnectCusForMatch(filterCustomerCode, filterCustomerName));
      } else if (groupType == UserTypes.GroupSupplier) {
        dispatch(findErpSupForMatch(filterCustomerCode, filterCustomerName));
      } else {
        alert(`Not support groupType (${groupType})`);
      }
    } catch (e) {
      alert((e as any).message);
    }
  }

  const parterList = groupType == UserTypes.Group ? findDConnectCust : groupType == UserTypes.GroupSupplier ? findErpSup : [];

  return (
    <Modal isOpen={isOpen} toggle={onModalClose} tabIndex={-1} centered scrollable size="xl" >
      <ModalHeader className="bg-primary" toggle={onModalClose}>
        <div className="modal-title-custom text-white font-size-16 ">
          เลือกบริษัท {capPartner} จาก ระบบ ERP
          &nbsp;{findDConnectCustOn && (<Spinner size={"sm"} />)}

        </div>
      </ModalHeader>
      <ModalBody className="p-4 ">
        <Form>
          {errMessage && (
            <div className="mb-3">
              <div className={"alert alert-" + errClass + " text-center"}>{errMessage}</div>
            </div>
          )}
          <div className="mb-3">
            {/* <span onClick={fnTest}>content</span> */}
            <div className="row">
              <div className="col">
                ชื่อห้องในแชท <span className={Utils.GetCssSuffixTheme("spn-info-hilight")}>{groupInfo?.groupId}:{groupInfo?.groupName}</span>
              </div>
              <div className="col">
                บริษัท {capPartner} ใน ERP&nbsp;
                <span className={Utils.GetCssSuffixTheme("spn-info-hilight")}>
                  {groupInfo?.companyId && (<>{groupInfo?.companyId}:{groupInfo?.companyName} ({groupInfo?.appName})</>)}
                  {!groupInfo?.companyId && (<span style={{ "color": "red" }}>ยังไม่ได้จับคู่</span>)}
                  {groupInfo?.companyId && (
                    <span className="hand"
                      onClick={() => onClickUnMatch(groupInfo?.groupId, groupInfo?.groupName, groupInfo?.companyName)}
                      style={{ "color": "red", marginLeft: "4px", paddingLeft: "6px", paddingRight: "6px", border: "solid 1px red", borderRadius: "5px" }}
                    ><span className="mdi mdi-close"></span>เลิกจับคู่</span>
                  )}
                </span>
              </div>
            </div>
            <div className="row pt-2">
              <div className="col">
                <i style={{ "color": "gray" }}>เลือกบริษัท {capPartner} จาก ERP เพื่อจับคู่กับห้อง Chat</i>
              </div>
            </div>

            <div className="row">
              <div className="mb-2 col-sm-5 col-md-4 col-lg-5 col-xl-5">
                <TextBox type="text" placeholder={`รหัส ${capPartner}`} className="form-control" value={filterCustomerCode} onEnter13={onSearchClick} onChange={(e) => setFilterCustomerCode(e.target.value)} />
              </div>
              <div className="mb-2 col-sm-7 col-md-5 col-lg-5 col-xl-6">
                <TextBox type="text" placeholder={`ชื่อ ${capPartner}`} className="form-control" value={filterCustomerName} onEnter13={onSearchClick} onChange={(e) => setFilterCustomerName(e.target.value)} />
              </div>
              <div className="mb-2 col-sm-12 col-md-3 col-lg-2 col-xl-1 text-end">
                <button type="button" className="btn btn-primary w-100" onClick={onSearchClick}>ค้นหา</button>
              </div>
            </div>

            <div className="add-member-to-group-modal-body" style={{ overflow: "auto" }}>
              <table className="table table-bordered table-striped chat-table">
                <thead className="thead-dark">
                  <tr>
                    <th>รหัส {capPartner}</th>
                    {groupType == UserTypes.Group && (<th>ระบบ</th>)}
                    <th>ชื่อ {capPartner}</th>
                    <th>ที่อยู่</th>
                    <th>จังหวัด</th>
                    <th>ห้องแชท</th>
                  </tr>
                </thead>
                <tbody>
                  {(parterList/*findDConnectCust*/ || []).map((item: any, key: number) => {
                    let code, name = "", appName = "", address, province, chatGroupName;
                    let partnerId = -1;
                    switch (groupType) {
                      case UserTypes.Group:
                        partnerId = item.customerID;
                        code = item.customerCode;
                        appName = item.appName;
                        name = item.customerName;
                        address = item.customerBillAddress;
                        province = item.customerProvince;
                        chatGroupName = item.chatGroupName;
                        break;
                      case UserTypes.GroupSupplier:
                        partnerId = item.supplierID;
                        code = item.supplierCode;
                        appName = "ERP";
                        name = item.supplierName;
                        address = item.supplierAddress;
                        province = item.supplierProvince;
                        chatGroupName = item.chatGroupName;
                        break;
                    }
                    return (
                      <tr key={key}>
                        <td>{code}</td>
                        {groupType == UserTypes.Group && (<td>{appName}</td>)}
                        <td>{name}</td>
                        <td>{address}</td>
                        <td>{province}</td>
                        <td>
                          {chatGroupName
                            ? (<div style={{ "color": "blue" }}>{chatGroupName}</div>)
                            : (<div style={{ "color": "red" }} onClick={() => onClickMatch(partnerId, name, appName)}>
                              เลือก
                            </div>)}
                          {/* <LoadingIconWithText/> */}
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>


          </div>
        </Form>
      </ModalBody>
      <ModalFooter>
        <Button type="button" color="link" className="btn" onClick={onModalClose} >
          ปิด
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default SearchCustomerModalV2;
